import type { Meta, Reference } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSThumbnail, useCMSReference } from '@swf/cms';

import useGeoVisibility from '../CMSContainer/hooks/useGeoVisibility';

const TilesGridItem: React.FC<Reference> = (props) => {
  const { thumbnail, visibility_rules: visibilityRules } = useCMSReference<Meta>(props) as Meta;
  const [isVisible] = useGeoVisibility(visibilityRules);

  if (isVisible) {
    return <CMSThumbnail {...thumbnail} />;
  }

  return null;
};

export default TilesGridItem;
